
module.exports = { 
      attributes: {},
    
      body: "General health services refers to any and all health services from including community, primary, hospital and specialist health services.\n",
    
      meta: {"resourcePath":"/home/vsts/work/1/s/src/tenants/amh/content/categoryDescription/default/general-health-services.md"},
     }